/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["mat-sidenav-container[_ngcontent-%COMP%]{height:100%}mat-card-content[_ngcontent-%COMP%]{padding-top:20px}.preview[_ngcontent-%COMP%]{padding:20px 50px;display:flex;flex-wrap:wrap;justify-content:space-around}.preview-card[_ngcontent-%COMP%]{cursor:pointer;width:400px;margin-bottom:40px}"];
export { styles as styles };
